import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Dramas from "@/pages/dramas/page";
import DramaDetail from "@/pages/drama/page";
import Calendar from "@/pages/calendar/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dramas",
    element: <Dramas />,
  },
  {
    path: "/drama/:id",
    element: <DramaDetail />,
  },
  {
    path: "/calendar",
    element: <Calendar />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;